import { styled } from "@mui/material/styles";
import { Grid, TextField } from "@mui/material";

export const StyledTextField = styled(TextField)({
  "& input": {
    padding: "5px",
    // width: "40px",
    textAlign: "end",
  },
  "& .MuiInputBase-root.MuiOutlinedInput-root ": {
    borderRadius: "5px",
    width: "100px",
  },
});

export const StyledCustomTextFieldContainer = styled(Grid)({
  position: "relative",
  "& input": {
    padding: "5px",
    textAlign: "end",
  },
  "& .MuiInputBase-root.MuiOutlinedInput-root ": {
    borderRadius: "5px",
    width: "100px",
  },
});

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignItems: "end",
  justifyContent: "end",
  gap: "2px",
  position: "relative",
  whiteSpace: "nowrap",
});

export const HintContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "end",
  whiteSpace: "nowrap",
  padding: "0px",
  fontSize: "12px",
  "& .MuiButtonBase-root": {
    height: "12px",
    justifyContent: "end",
    fontSize: "12px",
    color: theme.palette.error.main,
    gap: "5px",
  },
}));

export const StyledConfigHintContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignContent: "space-between",
  "& span": {
    lineHeight: 0,
  },
  "& svg": {
    height: "15px",
    width: "20px",
  },
});
